// extracted by mini-css-extract-plugin
export default {"icon":"hz-components-icon-index-icon"};